/**
 * Phase 0 の通過条件は「何も言わずに『もう1回』が押されるか。平均リトライ 3 回以上」。
 * プロトタイプ自身にその計測を持たせる。判断材料を後から人手で集めないための仕掛け。
 */
const KEY = 'etw:phase0';

export interface Phase0Metrics {
  /** 開始した走行の数。 */
  starts: number;
  /** 浜まで帰り着いた走行の数。 */
  finishes: number;
  /** 帰還タイムの合計（秒）。 */
  totalRunSeconds: number;
  bestTimeSeconds: number | null;
  bestTotalScore: number;
  /** 最初に触った時刻。セッション長の目安に使う。 */
  firstSeenAt: number;
  lastSeenAt: number;
}

function blank(): Phase0Metrics {
  return {
    starts: 0,
    finishes: 0,
    totalRunSeconds: 0,
    bestTimeSeconds: null,
    bestTotalScore: 0,
    firstSeenAt: Date.now(),
    lastSeenAt: Date.now(),
  };
}

export function loadMetrics(): Phase0Metrics {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return blank();
    return { ...blank(), ...(JSON.parse(raw) as Partial<Phase0Metrics>) };
  } catch {
    return blank();
  }
}

export function saveMetrics(metrics: Phase0Metrics): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...metrics, lastSeenAt: Date.now() }));
  } catch {
    // localStorage が使えない環境（プライベートブラウズ等）では計測を諦める。
  }
}

export function recordStart(metrics: Phase0Metrics): Phase0Metrics {
  const next = { ...metrics, starts: metrics.starts + 1 };
  saveMetrics(next);
  return next;
}

export function recordFinish(
  metrics: Phase0Metrics,
  timeSeconds: number,
  total: number,
): Phase0Metrics {
  const next: Phase0Metrics = {
    ...metrics,
    finishes: metrics.finishes + 1,
    totalRunSeconds: metrics.totalRunSeconds + timeSeconds,
    bestTimeSeconds:
      metrics.bestTimeSeconds === null ? timeSeconds : Math.min(metrics.bestTimeSeconds, timeSeconds),
    bestTotalScore: Math.max(metrics.bestTotalScore, total),
  };
  saveMetrics(next);
  return next;
}
